export const makeFirstCharCapital = (text, delimitter = " ") => {
  const tempText = text.split(delimitter);
  let resData = "";
  tempText?.forEach((element) => {
    resData =
      resData + element.charAt(0).toUpperCase() + element.slice(1) + delimitter;
  });
  return resData;
};

export const getItemDetailsFromRedux = (itemId, allFoods) => {
  const itemDetails = allFoods?.filter((f) => f._id === itemId);
  if (!itemDetails || itemDetails.length === 0) return null;
  return itemDetails[0];
};

// Display format for every amount: always exactly 2 decimals (23.14,
// 23.10, 23.00). Missing or invalid values show as 0.00
export const formatAmount = (value) => {
  const num = Number(value);
  return (Number.isFinite(num) ? num : 0).toFixed(2);
};

// Mobile number of an outlet customer record. Each record has its own _id;
// the same mobile number can be a customer of several outlets
export const customerMobileOf = (customer) =>
  customer?.mobileNumber === undefined || customer?.mobileNumber === null
    ? ""
    : String(customer.mobileNumber);
